import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { 
  initGA, 
  trackPageView, 
  trackEvent, 
  trackFormSubmission, 
  trackFileUpload, 
  trackReviewCreation, 
  trackReviewCompletion, 
  trackReviewCreated,
  trackFileUploaded,
  trackButtonClick,
  trackAuthEvent, 
  trackSubscriptionEvent, 
  trackError,
  trackAnonymousReviewConversion,
  trackSignUpConversion
} from '../lib/analytics';

// Custom hook for Google Analytics
export const useAnalytics = () => {
  const location = useLocation();

  // Initialize GA on mount
  useEffect(() => {
    initGA();
  }, []);

  // Track page views on route changes
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return {
    // Page tracking
    trackPageView,
    
    // Event tracking
    trackEvent,
    
    // Form tracking
    trackFormSubmission,
    
    // File tracking
    trackFileUpload,
    trackFileUploaded, // Legacy compatibility
    
    // Review tracking
    trackReviewCreation,
    trackReviewCompletion,
    trackReviewCreated, // Legacy compatibility
    
    // Button tracking
    trackButtonClick, // Legacy compatibility
    
    // Auth tracking
    trackAuthEvent,
    
    // Subscription tracking
    trackSubscriptionEvent,
    
    // Error tracking
    trackError,
    
    // Conversion tracking
    trackAnonymousReviewConversion,
    trackSignUpConversion,
  };
};

// Hook for tracking user engagement time
export const useEngagementTracking = () => {
  useEffect(() => {
    let startTime = Date.now();
    
    const handleVisibilityChange = () => {
      if (document.hidden) {
        // User left the page
        const engagementTime = Date.now() - startTime;
        if (engagementTime > 1000) { // Only track if user was engaged for more than 1 second
          // You can implement engagement tracking here if needed
        }
      } else {
        // User returned to the page
        startTime = Date.now();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
}; 